/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Update_SettingsInputs */



/**
* | output |
* | --- |
* | "Update Settings" |
*
* @param {Update_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const update_settings = /** @type {((inputs?: Update_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Update_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mettre à jour")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einstellungen aktualisieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiorna impostazioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновить настройки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizar configuración")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("設定を更新")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सेटिंग्स अपडेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizar configurações")
	return /** @type {LocalizedString} */ ("Update Settings")
});